module.exports = new __parcel__URL__("0pi.7ff142dc.png").toString();